<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.quartzTaskStatus === 'D' || row.quartzTaskStatus === 'S'
              ? 'warning'
              : row.quartzTaskStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_quartzTaskStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.quartzTaskCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="row.quartzTaskStatus !== 'D'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.quartzTaskCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="row.quartzTaskStatus === 'S' || row.quartzTaskStatus === 'N'"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="
                update({
                  code: row.quartzTaskCode,
                  type: 'del',
                  msg: $l('tips_delete_task') || '是否删除该自动任务？',
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_execution') || '执行'"
            placement="top"
            v-if="row.quartzTaskStatus === 'N' || row.quartzTaskStatus === 'Y'"
          >
            <i
              class="el-icon-video-play tool-btn"
              @click="
                update({
                  code: row.quartzTaskCode,
                  type: 'execution',
                  msg: $l('tips_carry_out_task') || '是否执行该自动任务？',
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_stop') || '暂停'"
            placement="top"
            v-if="
              row.quartzTaskStatus === 'N' ||
                row.quartzTaskStatus === 'Y' ||
                row.quartzTaskStatus === 'P'
            "
          >
            <i
              class="el-icon-video-pause tool-btn"
              @click="
                update({
                  code: row.quartzTaskCode,
                  type: 'reduction',
                  msg: $l('tips_abort_task') || '是否暂停该自动任务？',
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_recovery') || '恢复'"
            placement="top"
            v-if="row.quartzTaskStatus === 'S' || row.quartzTaskStatus === 'D'"
          >
            <i
              class="el-icon-refresh-left tool-btn"
              @click="
                update({
                  code: row.quartzTaskCode,
                  type: 'resume',
                  msg: $l('tips_resume_task') || '是否恢复该自动任务？',
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'system-sysQuartzTask-detail',
        params: { ...params, pageType },
      })
    },
    update({ code = '', type = '', msg }) {
      this.$confirm(msg, this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        let requestApi
        if (type === 'del') {
          //删除
          requestApi = this.$api.sysQuartzTaskDelApi({
            quartzTaskCode: code,
          })
        } else if (type === 'reduction') {
          //暂停
          requestApi = this.$api.sysQuartzTaskPauseApi({
            quartzTaskCode: code,
          })
        } else if (type === 'execution') {
          //执行
          requestApi = this.$api.sysQuartzTaskRunApi({
            quartzTaskCode: code,
          })
        } else if (type === 'resume') {
          //恢复
          requestApi = this.$api.sysQuartzTaskResumeApi({
            quartzTaskCode: code,
          })
        }
        requestApi.then((res) => {
          const { status, msg } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: msg,
              type: 'success',
            })
            this.$emit('reload')
          }
        })
      })
    },
  },
}
</script>
